import React from 'react';
import { Field, reduxForm, formValueSelector, initialize } from 'redux-form';
import { Form, Button } from 'react-bootstrap';
import { Checkbox, FormActions } from '../../common/components/formControls';
import TimeZonePicker from './TimeZonePicker';
import { withTranslation } from 'react-i18next';

const TimeZoneSettingsForm = ({ handleSubmit, pristine, submitting, t, defaultTimeZone, isAutomaticTimeZone }) => {
	return (
		<Form onSubmit={handleSubmit}>
			<Field name='isAutomaticTimeZone' component={Checkbox} label={t('AdminPanelSettings_TimeZone_IsAutomatic')} />
			<TimeZonePicker name='timeZone' disabled={isAutomaticTimeZone} label={t('AdminPanelSettings_TimeZone_Select')} emptyValue={defaultTimeZone} />
			<FormActions>
				<Button type='submit' disabled={pristine || submitting} bsStyle='primary'>{t('AdminPanelSettings_Apply')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'timeZoneSettings' })(withTranslation()(TimeZoneSettingsForm));

export const selector = formValueSelector('timeZoneSettings');
export const initializeForm = () => initialize('timeZoneSettings');